<template>
	<div class="loader">
		<animated-logo />
	</div>
</template>

<script>
import AnimatedLogo from '@/components/Loaders/AnimatedLogo.vue'

export default {
	name: 'Loader',

	components: {
		AnimatedLogo
	}
}
</script>

<style lang="scss">
.loader {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);
	z-index: 500;

	.animated-logo {
		position: absolute;
		top: 50%;
		left: 50%;
		margin: 0;
		transform: translate(-50%, -50%);
		content: '';
	}
}
</style>
